<template>
  <main-layout>
    <div slot="left-side">
      <menubar screenIdParam="M-06-97"></menubar>
    </div>

    <el-row slot="header">
      <head-title class="cancel-width">
        <label v-if="isCreateMode" slot="title">
          サイネージページ作成
        </label>
        <label v-else slot="title">
          サイネージページ編集
        </label>
        <button-index slot="cancel" @click="clickCancel">
          {{ $t("button.common.cancel") }}
        </button-index>
        <div slot="create">
          <button-index
            v-if="query.cmsId == null"
            slot="create"
            class="create-button-mapinfo"
            @click="createdAndUpdateApi"
          >
            {{ $t("button.common.data.create") }}
          </button-index>
          <button-index
            v-else
            slot="create"
            class="create-button-mapinfo"
            @click="createdAndUpdateApi"
          >
            {{ $t("button.common.data.update") }}
          </button-index>
        </div>
      </head-title>
    </el-row>

    <div slot="body">
      <el-form
        :rules="rules"
        :model="query"
        ref="ruleForm"
      >
        <!-- ページ設定 -->
        <div class="flex-space-between m-bottom-3">
          <div class="environment-title">
            <span class="requir-item-right">
              {{ $t("visual.create.requir") }}
            </span>
            <span>
              {{ $t("visual.create.requirTitle") }}
            </span>
          </div>
        </div>
        <div class="main-title m-bottom-2">
          {{ $t("visual.create.pageSetting") }}
        </div>
        <div class="main-hr mapinfo-bottom-34" />
        <div class="flex-align-items-center m-bottom-4">
          <!-- ページ名 -->
          <div class="flex-align-items-center m-right-5">
            <div class="sub-label m-right-3">
              ページ名
              <span class="requir-item">{{$t("visual.create.requir")}}</span>
            </div>
            <div>
              <el-form-item
                style="margin-bottom: 0px !important;"
                prop="cmsTitle"
              >
                <el-input
                  class="new-input-style w-520 show-word-limt-input"
                  maxlength="30"
                  placeholder="例：２８F"
                  show-word-limit
                  v-model="query.cmsTitle"
                />
              </el-form-item>
            </div>
          </div>
        </div>

        <div class="sub-hr m-bottom-4" />

        <div class="flex-align-items-center m-bottom-4">
          <!-- サブタイトル -->
          <div class="flex-align-items-center m-right-5">
            <div class="sub-label m-right-3">
              サブタイトル
            </div>
            <div>
              <el-form-item
                style="margin-bottom: 0px !important;"
                prop="cmsSubTitle"
              >
                <el-input
                  class="new-input-style w-520 show-word-limt-input"
                  maxlength="30"
                  placeholder="例：ワーキングエリア"
                  :show-word-limit="true"
                  v-model="query.cmsSubTitle"
                />
              </el-form-item>
            </div>
          </div>
        </div>

        <div class="sub-hr m-bottom-4" />

        <div class="flex-align-items-center m-bottom-4">
          <!-- サイネージ種別 -->
          <div class="flex-align-items-center m-right-5">
            <div class="sub-label m-right-3">
              サイネージ種別
            </div>
            <div>
              <el-form-item
                style="margin-bottom: 0px !important;"
                prop="typeCode"
              >

              <el-select
                v-model="typeCode"
                @change="typeCodeChange"
              >
                <el-option
                  v-for="item in displayMethodList"
                  :key="item.code"
                  :label="item.value"
                  :value="item.code"
                >
                </el-option>
              </el-select>
              </el-form-item>
            </div>
          </div>
        </div>

        <div class="sub-hr m-bottom-4" />

        <!-- 表示項目 -->
        <div class="sub-label m-bottom-3 passwordDiv" style="width: 555px;" v-if="typeCode=='01'">
          <div class="sub-label m-right-3 ">
            {{ $t("label.system.VisualPageManagementCreate.displayItem") }}
          </div>
          <div style="display: flex; align-items: center;">
            <span>
              {{ $t("label.system.VisualPageManagementCreate.title") }}
            </span>
            <el-switch style="margin-left: 12px;" v-model="showTitleFlag" />
          </div>
        </div>

        <!-- 表示サイズ -->
        <div class="sub-label m-bottom-4 passwordDiv"  style="width: 555px;">
          <div class="sub-label m-right-3 text-nowrap">
            {{ $t("label.system.VisualPageManagementCreate.displaySize") }}
          </div>
          <div>

              <el-radio-group v-model="fontSize" class="radio-group-style">
                <!-- 小 -->
                <div class="radio-style">
                  <div class="margin-r-8">
                    {{ $t("label.system.VisualPageManagementCreate.small") }}
                  </div>
                  <el-radio label="01" />
                </div>

                <!-- 中 -->
                <div class="radio-style">
                  <div class="margin-r-8">
                    {{ $t("label.system.VisualPageManagementCreate.medium") }}
                  </div>
                  <el-radio label="02" />
                </div>

                <!-- 大 -->
                <div class="radio-style">
                  <div class="margin-r-8">
                    {{ $t("label.system.VisualPageManagementCreate.large") }}
                  </div>
                  <el-radio label="03" />

                </div>

                <!-- 特大 -->
                <div class="radio-style">
                  <div class="margin-r-8">
                    {{ $t("label.system.VisualPageManagementCreate.extraLarge") }}
                  </div>
                  <el-radio label="04" />
                </div>

              </el-radio-group>
          </div>
        </div>

        <div class="sub-hr m-bottom-4" />

        <!-- 配信用URL -->
        <div class="sub-label m-bottom-2">
          配信用URL
        </div>

        <!-- 配信用URL -->
        <div class="flex-space-between">
          <div v-if="!isCreateMode" class="panel-tab-mapinfo">
            {{ url }}
          </div>
          <div v-else class="panel-tab-mapinfo"></div>
          <div class="right-btn">
            <button-index
              class="setting-button"
              v-show="!isCreateMode"
              @click="copyClick('01')"
            >
              コピー
            </button-index>
          </div>
        </div>

        <!-- パスワード設定 -->
        <div class="sub-label m-bottom-3 passwordDiv">
          <span>
            パスワード設定
          </span>
          <span class="on-switch">
            <el-switch v-model="passwordShowFlag" @change="!passwordShowFlag" />
          </span>
        </div>

        <!-- パスワード設定 -->
        <div v-if="passwordShowFlag" class="flex-space-between">
          <div class="panel-tab-mapinfo">
            {{ password }}
          </div>
          <div class="right-btn">
            <button-index
              class="setting-button"
              @click="copyClick('02')"
            >
              コピー
            </button-index>
          </div>
        </div>

        <div class="sub-hr m-bottom-4 m-top-4" />

        <!-- 画面設定 -->
        <div class="sub-label m-bottom-2 flex-space-between">
          <!-- title -->
          <div class="flex-align-items-center">
            <div class="m-right-1">
              画面設定
              <span class="requir-item">
                {{ $t("visual.create.requir") }}
              </span>
            </div>
          </div>
        </div>

        <div
          class="device-group-list"
          style="display: flex;"
          v-if="selectResourceInfoList.length > 0"
        >
          <div class="body" style="width: 90%;">
            <div class="col">
              <div>
                <cms-page-management-result-beautify
                  :isShow="selectResourceInfoList.length > 0"
                  :result="selectResourceInfoList"
                  :displayMethod="typeCode"
                />
              </div>
            </div>
          </div>

          <div class="right-btn">
            <button-index
              class="setting-button"
              @click="showScreenSettingsPopup"
            >
              設定
            </button-index>
          </div>

        </div>

        <div v-else class="flex-space-between">
          <div v-show="typeCode == '01'" class="panel-tab-mapinfo">
            環境可視化ページが未設定です
          </div>
          <div v-show="typeCode != '01'" class="panel-tab-mapinfo">
            対象施設が未設定です
          </div>
          <div class="right-btn">
            <button-index
              class="setting-button"
              @click="showScreenSettingsPopup"
            >
              設定
            </button-index>
          </div>
        </div>

        <div class="sub-hr m-bottom-4" />

        <div class="m-bottom-4">
          <!-- IPアドレス制限 -->
          <div class="m-right-5">
            <div class="sub-label m-right-3" style="position: relative; top: 25px;">
              IPアドレス制限
            </div>
            <el-switch style="margin-left: 145px;margin-bottom: 10px;" v-model="query.ipControlFlag" @change="!query.passwordShowFlag"/>

            <div v-if="query.ipControlFlag" style="margin-left: 128px;">
              <el-form-item
                v-for="(item, index) in query.ipList"
                :key="'sendIp_' + index"
                :class="index === query.ipList.length - 1 ? '' : 'm-bottom-2'"
              >
                <div class="ip-input m-left-2">
                  <el-form-item
                    :prop="'ipList.' + index + '.sendIp'"
                    :rules="[
                      {
                        required: true,
                        message: 'IPアドレス制限は必須項目です。',
                        trigger: 'change',
                      },
                      {
                        // pattern: /^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/(\d|[1-2]\d|3[0-2]))?$|^([\da-fA-F]{1,4}:){6}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^::([\da-fA-F]{1,4}:){0,4}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:):([\da-fA-F]{1,4}:){0,3}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){2}:([\da-fA-F]{1,4}:){0,2}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){3}:([\da-fA-F]{1,4}:){0,1}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){4}:((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^:((:[\da-fA-F]{1,4}){1,6}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^[\da-fA-F]{1,4}:((:[\da-fA-F]{1,4}){1,5}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){2}((:[\da-fA-F]{1,4}){1,4}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){3}((:[\da-fA-F]{1,4}){1,3}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){4}((:[\da-fA-F]{1,4}){1,2}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){5}:([\da-fA-F]{1,4})?(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){6}:(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$/,
                        pattern: /^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/(\d|[1-2]\d|3[0-2]))$|^([\da-fA-F]{1,4}:){6}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))$|^::([\da-fA-F]{1,4}:){0,4}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))$|^([\da-fA-F]{1,4}:):([\da-fA-F]{1,4}:){0,3}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))$|^([\da-fA-F]{1,4}:){2}:([\da-fA-F]{1,4}:){0,2}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))$|^([\da-fA-F]{1,4}:){3}:([\da-fA-F]{1,4}:){0,1}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))$|^([\da-fA-F]{1,4}:){4}:((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))$|^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))$|^:((:[\da-fA-F]{1,4}){1,6}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))$|^[\da-fA-F]{1,4}:((:[\da-fA-F]{1,4}){1,5}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))$|^([\da-fA-F]{1,4}:){2}((:[\da-fA-F]{1,4}){1,4}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))$|^([\da-fA-F]{1,4}:){3}((:[\da-fA-F]{1,4}){1,3}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))$|^([\da-fA-F]{1,4}:){4}((:[\da-fA-F]{1,4}){1,2}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))$|^([\da-fA-F]{1,4}:){5}:([\da-fA-F]{1,4})?(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))$|^([\da-fA-F]{1,4}:){6}:(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))$/,
                        trigger: 'change',
                        // message: $t('message.common.error.ERR_TYPE_MSG')
                        message: '正しいCIDRフォーマットのIPアドレス/IPアドレス帯を入力してください。'
                      }
                    ]"
                  >
                  <!-- :disabled = "!$IsSBManager()" -->

                    <el-input
                      v-model="item.sendIp"
                      maxlength="50"
                      placeholder="アクセスを許可するIPアドレス">
                    </el-input>
                  </el-form-item>
                </div>
                <!-- v-show="$IsSBManager()"  -->
                <div v-if="index === query.ipList.length - 1" class="ip-add m-left-2">
                  <button type="button" class="el-button add_button el-button--default is-circle able_div" @click="addNewInput">
                  </button>
                </div>
                <div
                  v-if="index > 0 || query.ipList.length > 1"
                  class="ip-add m-left-2">
                  <button type="button" class="el-button minus_button el-button--default is-circle able_div" @click="removeInput(index)">
                  </button>
                </div>

              </el-form-item>
            </div>
          </div>
        </div>

      </el-form>

      <loading-dialog :dialogVisible="showLoading" />

      <cms-screen-settings-popup
        :visible.sync="showScreenSettingsPopupFlg"
        fromType="01"
        @on-selected="getEnvViewPage"
      />

      <cms-screen-settings-meeting-popup
        :diplayMethod="typeCode"
        :visible.sync="showScreenSettingsMeetingPopupFlg"
        :selectResourceInfoList="selectResourceInfoList"
        @on-checked="getMeetingRoomInfo"
      />

      <dialog-confirm
        :clickFlag="false"
        :visible.sync="isDialogConfirmComplete"
        :titleMsg="dialogComplete.title"
        :contentMsg="dialogComplete.content"
        :cancelFlag="cancelFlag"
        :colorFlag="true"
        @on-confirm="createdOrUpdateApi"/>
    </div>

  </main-layout>
</template>

<script>
import api from "@/api/SystemManageApi"
import MainLayout from "@/layout/NewDesignLayout"
import headTitle from "@/components/common/head/head"
import Menubar from "@/components/leftmenu/DashBoard"
import buttonIndex from "@/components/common/sp-smart-button/index"
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import statusErrorCodeMsg from "@/utils/status-error-msg"
import errorCodeMsg from "@/utils/error-code-msg"
import CmsPageManagementResultBeautify from "@/components/system/CmsPageManagementResultBeautify"
import CmsScreenSettingsPopup from '@/components/system/popup/CmsScreenSettingsPopup'
import CmsScreenSettingsMeetingPopup from '@/components/system/popup/CmsScreenSettingsMeetingPopup'
import Configuration from "@/config/index"
import DialogConfirm from "@/components/common/el-dialog-prompt/confirm";

export default {
  name: "VisualPageManagementCreate",
  components: {
    MainLayout: MainLayout,
    headTitle: headTitle,
    LoadingDialog: LoadingDialog,
    buttonIndex: buttonIndex,
    Menubar: Menubar,
    CmsPageManagementResultBeautify,
    CmsScreenSettingsPopup,
    CmsScreenSettingsMeetingPopup,
    DialogConfirm
  },
  data() {
    return {
      displayMethodList: [
        { code: "01", value: "マップ" },
        { code: "02", value: "リスト（画像あり）" },
        { code: "03", value: "リスト（画像なし）" },
        { code: "04", value: "カレンダー" },
      ],
      cancelFlag: true,
      isDialogConfirmComplete: false,
      dialogComplete: {
        title:"登録確認",
        content:"この内容で登録しますか？",
      },
      showScreenSettingsPopupFlg: false,
      showScreenSettingsMeetingPopupFlg: false,
      url: "",
      password: "",
      passwordShowFlag: true,
      showLoading: false,
      typeCode: '',
      isCreateMode: false,
      query: {
        ownerId: null,
        ownerName: null,
        ownerExId: null,
        buildingId: null,
        buildingName: null,
        buildingExId: null,
        floorId: null,
        floorName: null,
        areaId: null,
        areaName: null,
        cmsId: null,
        ipControlFlag: false,
        cmsTitle: null,
        cmsSubTitle: null,
        diplayMethod: null,
        resourceIdList: [],
        resourceInfoList: [
          {
            resourceName: null,
            resourceId: null,
            ownerName: null,
            ownerExId: null,
            ownerId: null,
            buildingName: null,
            buildingExId: null,
            buildingId: null,
            floorId: null,
            floorName: null,
            areaId: null,
            areaName: null,
            displayOrder:0
          }
        ],
        ipList: [
          {sendIp: null,}
        ]
      },
      selectResourceInfoList: [],
      rules: {
        cmsTitle: [
          {
            required: true,
            trigger: 'change',
            message: this.$t('message.common.validation.required', {
              field: "ページ名"
            })
          },
          {
            max: 30,
            trigger: 'change',
            message: this.$t('message.common.validation.max', {
              field: "ページ名",
              length: 30
            })
          }
        ],
        cmsSubTitle: [
          {
            max: 30,
            trigger: 'change',
            message: this.$t('message.common.validation.max', {
              field: "サブタイトル",
              length: 30
            })
          }
        ]
      },
      showTitleFlag:true,
      fontSize:"01",
    }
  },
  created() {
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "/cms/page/management",
        title: "サイネージ",
      },
      {
        path: "",
        title: "サイネージページ",
      },
    ];
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
    this.$authCheck("060401");
    this.$authCheck("060403");

  },
  mounted() {
    this.getPageInfo()
  },
  methods: {
    typeCodeChange() {
      this.selectResourceInfoList = []
      this.query.resourceIdList = []
    },
    getMeetingRoomInfo: function (meetingRoomInfoList){
      this.query.resourceIdList = []
      // this.selectResourceInfoList = []
      if (Array.isArray(meetingRoomInfoList) && meetingRoomInfoList.length > 0) {

        // ① meetingRoomInfoList を基準にした roomId Set
        const meetingRoomIdSet = new Set(
          meetingRoomInfoList.map(item => String(item.roomId))
        );

        // ② meetingRoomInfoList に存在しない resource を削除
        this.selectResourceInfoList = this.selectResourceInfoList.filter(item =>
          meetingRoomIdSet.has(String(item.resourceId))
        );

        // ③ 現在の selectResourceInfoList の resourceId Set
        const resourceIdSet = new Set(
          this.selectResourceInfoList.map(item => String(item.resourceId))
        );

        // ④ 不足分を追加
        for (const meetingRoomInfo of meetingRoomInfoList) {

          if (resourceIdSet.has(String(meetingRoomInfo.roomId))) {
            continue;
          }

          this.selectResourceInfoList.push({
            buildingId: meetingRoomInfo.buildingId,
            buildingName: meetingRoomInfo.buildingName,
            floorId: meetingRoomInfo.floorId,
            floorName: meetingRoomInfo.floorName,
            areaId: meetingRoomInfo.areaId,
            areaName: meetingRoomInfo.areaName,
            resourceId: meetingRoomInfo.roomId,
            resourceName: meetingRoomInfo.roomName,
            displayOrder: 0
          });
          resourceIdSet.add(String(meetingRoomInfo.roomId));
        }

        // ⑤ displayOrder を 1 から振り直す
        this.selectResourceInfoList.forEach((item, index) => {
          item.displayOrder = index + 1;
        });
      }


    },
    getEnvViewPage: function (envViewPage){
      this.selectResourceInfoList = []
      this.query.resourceIdList = []
      this.selectResourceInfoList.push({
        buildingId: envViewPage.buildingId,
        buildingName: envViewPage.buildingName,
        floorId: envViewPage.floorId,
        floorName: envViewPage.floorName,
        areaId: envViewPage.areaId,
        areaName: envViewPage.areaName,
        resourceId: envViewPage.pageId,
        resourceName: envViewPage.pageName,
        displayOrder:0
      })
      this.query.resourceIdList.push(envViewPage.pageId)
    },
    showScreenSettingsPopup(){
      if (this.typeCode == "01") {
        this.showScreenSettingsPopupFlg = true
      } else {
        this.showScreenSettingsMeetingPopupFlg = true
      }

    },
    generateRandom8Digit() {
      this.password = Math.floor(10000000 + Math.random() * 90000000).toString();
    },
    copyClick(val) {
      let value = ''
      if (val == '01') {
        value = this.url
      } else if (val == '02') {
        value = this.password
      }

      navigator.clipboard
      .writeText(value)
      .then(() => {
        this.$messageIotSuccess(
          this.$t("message.common.validation.successCopyMessageToText")
        );
      })
      .catch(() => {
        this.$messageIotError(this.$t("message.common.error.errorCopyLink"));
      });
    },
    clickCancel() {
      this.$router.push({
        name: "page-management"
      });
    },
    getPageInfo () {
      this.query.deviceGroupList = []
      this.query.publishAreaList = []
      this.requestList = []
      const cmsId = this.$route.query['cmsId'];
      if (cmsId == null) {
        this.typeCode = this.$route.params.type
        this.isCreateMode = true
        this.generateRandom8Digit()
      } else {
        this.isCreateMode = false
        this.query.cmsId = cmsId
        this.searchCmsPageDetailAPI()
      }
    },

    createdAndUpdateApi () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {

          if (this.selectResourceInfoList.length == 0) {
            this.$messageIotError(this.$t('message.common.validation.required', {
              field: "画面設定"
            }))
          } else {
            this.isDialogConfirmComplete = true
          }
        }
      })
    },

    createdOrUpdateApi () {

      //リソース対象リスト取得
      let resourceList = [];

      for( let resource of this.selectResourceInfoList){
        resourceList.push({
          resourceId: resource.resourceId,
          displayOrder: resource.displayOrder
        })
      }

      if (this.isCreateMode) {
        this.showLoading = true
        let ipList = []
        for (let i = 0; i < this.query.ipList.length; i++) {
          const element = this.query.ipList[i];
          ipList.push(element.sendIp)
        }
        let ipString = ipList.join(',');

        if(!this.query.ipControlFlag){
          ipString = ''
        }

        api.createdCmsPageDetail({
          areaId: this.selectResourceInfoList[0].areaId,
          cmsTitle: this.query.cmsTitle,
          ipControlFlag: this.query.ipControlFlag,
          cmsSubTitle: this.query.cmsSubTitle,
          diplayMethod: this.typeCode,
          password: this.password,
          passwordShowFlag: this.passwordShowFlag,
          resourceList: resourceList,
          ipList: ipString,
          showTitleFlag:this.showTitleFlag,
          fontSize:this.fontSize
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            if (data.statusCode == "Failure.CidrSpecificationIncorrect") {
              this.$messageIotError('正しいCIDRフォーマットのIPアドレス/IPアドレス帯を入力してください。')
            }
            return;
          }

          this.showLoading = false

          this.$messageIotSuccess(this.$t("message.common.createSuccess", {
            field: "サイネージ",
          }));

          this.query.cmsId = data.body.cmsId

          this.searchCmsPageDetailAPI()

        }).finally(() => {
          this.showLoading = false;
        })
      } else {
        this.showLoading = true
        let ipList = []
        for (let i = 0; i < this.query.ipList.length; i++) {
          const element = this.query.ipList[i];
          ipList.push(element.sendIp)
        }
        let ipString = ipList.join(',');

        if(!this.query.ipControlFlag){
          ipString = ''
        }

        api.updateCmsPageDetail(this.query.cmsId, {
          areaId: this.selectResourceInfoList[0].areaId,
          ipControlFlag: this.query.ipControlFlag,
          cmsTitle: this.query.cmsTitle,
          cmsSubTitle: this.query.cmsSubTitle,
          passwordShowFlag: this.passwordShowFlag,
          resourceList: resourceList,
          ipList: ipString,
          diplayMethod: this.typeCode,
          showTitleFlag:this.showTitleFlag,
          fontSize:this.fontSize
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            if (data.statusCode == "Failure.CidrSpecificationIncorrect") {
              this.$messageIotError('正しいCIDRフォーマットのIPアドレス/IPアドレス帯を入力してください。')
            }
            return;
          }

          this.showLoading = false;

          this.$messageIotSuccess(this.$t("message.common.updateSuccess", {
            field: "サイネージ",
          }));
          this.searchCmsPageDetailAPI()
        }).finally(() => {
          this.showLoading = false;
        })
      }
    },

    searchCmsPageDetailAPI() {
      this.isCreateMode = false
      this.showLoading = true
      this.showAreaMapUpdateBtn = false
      api.searchCmsPageDetail(this.query.cmsId)
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({ data }) => {
        if (!statusErrorCodeMsg(data.statusCode, this)) {
          return
        }
        this.query.ownerId = data.body.ownerId
        this.query.ownerName = data.body.ownerName
        this.query.ownerExId = data.body.ownerExId
        this.query.buildingId = data.body.buildingId
        this.query.buildingName = data.body.buildingName
        this.query.buildingExId = data.body.buildingExId
        this.query.floorId = data.body.floorId
        this.query.floorName = data.body.floorName
        this.query.areaId = data.body.areaId
        this.query.areaName = data.body.areaName
        this.query.cmsId = data.body.cmsId
        this.query.cmsTitle = data.body.cmsTitle
        this.query.cmsSubTitle = data.body.cmsSubTitle
        this.password = data.body.password
        this.passwordShowFlag = data.body.passwordShowFlag
        this.query.diplayMethod	= data.body.diplayMethod
        this.query.resourceInfoList = data.body.resourceInfoList
        this.query.ipControlFlag = data.body.ipControlFlag

        this.query.resourceIdList	= data.body.resourceList.map(item => item.resourceId);

        //タイトル表示フラグ
        this.showTitleFlag = data.body.showTitleFlag;
        //フォントサイズ
        this.fontSize = data.body.fontSize

        if(!this.query.ipControlFlag){
          this.query.ipList = [{sendIp: null,}]
        }else{
          if (this.$IsNullOrEmpty(data.body.ipList)) {
            this.query.ipList = [{sendIp: null,}]
          } else {
            this.query.ipList = data.body.ipList.split(',').map(ip => ({ sendIp: ip }));
          }
        }

        this.typeCode = this.query.diplayMethod

        this.url = Configuration['public.app.url'] + "/cms/CmsView?cms_id=" + this.query.cmsId


        // resourceList を resourceId → displayOrder の Map に変換
        const orderMap = new Map(
          data.body.resourceList.map(item => [item.resourceId, item.displayOrder])
        );

        this.selectResourceInfoList = []

        let resourceInfoList = data.body.resourceInfoList
        if(resourceInfoList && resourceInfoList.length > 0 ){
          // resourceInfoList を走査
          resourceInfoList.forEach(info => {
            // resourceList に同じ resourceId が存在するか確認
            if (orderMap.has(info.resourceId)) {
              // resourceInfoList のオブジェクトをベースに
              // resourceList 側の displayOrder を設定して追加
              this.selectResourceInfoList.push({
                ...info,
                displayOrder: orderMap.get(info.resourceId)
              });
            }
          });
        }


        //データ取得後、displayOrder に従って並び替える。
        this.selectResourceInfoList = this.selectResourceInfoList.sort((a, b) => a.displayOrder - b.displayOrder);


        // displayOrder がすべて 0 かどうか判定
        const isAllZero = this.selectResourceInfoList.every(
          item => item.displayOrder === 0
        );

        // すべて 0 の場合、現在の配列順で displayOrder を 1 から再設定
        if (isAllZero) {
          this.selectResourceInfoList.forEach((item, index) => {
            item.displayOrder = index + 1;
          });
        }

        this.showLoading = false
      }).finally(() => {
        this.showLoading = false;
      })
    },

    addNewInput(){
      this.query.ipList.push({
        sendIp: null
      })
    },
    removeInput(index) {
      this.query.ipList.splice(index, 1);
    },

  }
}
</script>

<style lang="scss" scoped>
::v-deep .cancel-width{
  .my-button{
    width: 152px;
    height: 32px;
  }
}
.flex-space-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flex-align-items-center {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.select-img {
  margin-top: 6px;
}

.environment-title {
  font-size: 12px;
  color: #525250;
}

.mapinfo-right-12 {
  margin-right: 12px;
}

.mapinfo-bottom-65 {
  margin-bottom: 65px;
}

.font-14-b {
  color: #525250;
  font-size: 14px;
}

.requir-item-right {
  color: #E65245;
  margin-right: -6px;
}

.requir-item {
  color: #E65245;
  margin-left: 0;
  position: absolute;
}

.main-title {
  font-family: 'Hiragino Kaku Gothic Pro', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  color: #525250;
}

.sub-label {
  font-family: 'Hiragino Kaku Gothic Pro', sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 16px;
  color: #525250;
  width: 118px;
}

.main-hr {
  height: 2px;
  width: 100%;
  background: #D1D1CD;
}

.sub-hr {
  height: 1px;
  width: 100%;
  background: #D1D1CD;
}

.mapinfo-bottom-34 {
  margin-bottom: 34px;
}

.w-520 {
  width: 520px;
  ::v-deep .el-input__inner {
    width: 520px !important;
  }
}


.panel-tab-mapinfo {
  height: 56px;
  padding-left: 24px;
  width: 90%;
  background: #F7F7F2;
  border-radius: 6px;
  display: flex;
  align-items: center;
  font-family: 'Hiragino Kaku Gothic Pro';
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 12px;
  color: #525250;
  margin-bottom: 24px;
}

::v-deep .panel-tab-mapinfo-table {
  margin-right: 30px;
  padding: 0 16px;
  width: 100%;
  background: #F7F7F2;
  border-radius: 8px;
}

::v-deep .panel-tab-mapinfo-table .el-table thead tr th {
  background-color: #F7F7F2 !important;
  background: #F7F7F2 !important;
}

::v-deep .panel-tab-mapinfo-table .el-table__body-wrapper {
  background-color: #F7F7F2 !important;
}

::v-deep .panel-tab-mapinfo-table .el-table__empty-block {
  background-color: #F7F7F2 !important;
}

::v-deep .panel-tab-mapinfo-table .el-table td {
  border-bottom: none !important;
}

.panel-tab-mapinfo-table-sub {
  margin-right: 30px;
  padding: 0 16px;
  width: 100%;
  background: #F7F7F2;
  border-radius: 8px;
}

::v-deep .panel-tab-mapinfo-table-sub .el-table thead tr th {
  background-color: #F7F7F2 !important;
  background: #F7F7F2 !important;
}

::v-deep .panel-tab-mapinfo-table-sub .el-table__body-wrapper {
  background-color: #F7F7F2 !important;
}

::v-deep .panel-tab-mapinfo-table-sub .el-table__empty-block {
  background-color: #F7F7F2 !important;
}

.setting-button {
  width: 122px;
  height: 32px;
}

.setting-button:disabled {
  background: #F2F2ED;
  opacity: 0.5;
  color: rgba(82, 82, 80, 0.6) !important;
}


.border {
  position: absolute;
  padding: 5px;
  border-style: solid;
  border-color: #3EDDE4;
  display: none;
}

.right-btn {
  margin-left: 30px;
  width: 10%;
  margin-bottom: 24px;
}

.create-button-mapinfo {
  background: #329CA6;
  color: #FFFFFF;
  box-shadow: -4px -4px 5px #FFFFFF,
               3px  3px 6px #B8B8AD;
}

.create-button-mapinfo:hover {
  opacity: 0.8;
  background: #329CA6;
  color: #FFFFFF !important;
  box-shadow: -4px -4px 5px #FFFFFF,
               3px  3px 6px #B8B8AD;
}

.create-button-mapinfo:disabled {
  background: #329CA6;
  opacity: 0.5;
  color: #FFFFFF;
  box-shadow: -4px -4px 5px #FFFFFF,
               3px  3px 6px #B8B8AD;
}
::v-deep .show-word-limt-input .el-input__inner{
  padding-right: 64px !important;
}
.passwordDiv {
  display: flex;
  align-items: center;
  width: 300px;
}
.on-switch {
  margin-left: 50px;
}
.ip-add{
  display: inline-block;
}

.ip-input {
  width: 324px;
  display: inline-block;
}

.add_button {
  height: 36px;
  width: 40px;
  border: none;
  background: url("../../../../assets/icon/sp-btn-add.png") no-repeat;
  background-size: 100%;
}

.add_button:hover {
  opacity: 0.6;
  height: 36px;
  width: 40px;
  border: none;
  background: url("../../../../assets/icon/sp-btn-add.png") no-repeat;
  background-size: 100%;
}

.minus_button {
  height: 36px;
  width: 40px;
  border: none;
  background: url("../../../../assets/icon/sp-btn-minus.png") no-repeat;
  background-size: 100%;
}

.minus_button:hover {
  opacity: 0.6;
  height: 36px;
  width: 40px;
  border: none;
  background: url("../../../../assets/icon/sp-btn-minus.png") no-repeat;
  background-size: 100%;
}
.radio-group-style {
  display:flex;
  font-size:16px;
}
.radio-style{
  display: flex;
  align-items: center;
  margin-right: 32px;
  white-space: nowrap;

  ::v-deep.el-radio .el-radio__label {
      font-size: 0 !important;
  }
}
.margin-r-8{
  margin-right:8px;
}
.text-nowrap{
  white-space: nowrap;
}
</style>
